<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Transport
      </div>
      <v-spacer></v-spacer>
      <v-btn color="primary" small @click="modal = true">Upload</v-btn>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="list"
      :loading="listLoader"
      :options.sync="options"
      :server-items-length="total"
      class="elevation-1 custom-icon-size mt-7"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <v-row class="custom-row mb-1 pl-5 pr-5">
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  hide-details
                  v-model="number"
                  label="Tender Request Number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  hide-details
                  v-model="shipment_reference_number"
                  label="Reference Number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  hide-details
                  v-model="container_number"
                  label="Container Number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  hide-details
                  v-model="seal_number"
                  label="Seal Value"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  outlined
                  hide-details
                  v-model="click_rf_event_id"
                  label="Status"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="9">
                <v-btn
                  color="white mt-3 v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                  class="ml-4"
                  @click="clearAll"
                  style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mt-3 v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
          <v-divider class="mb-5"></v-divider>
        </template>
      </template>
      <template v-slot:item.click_rf_event_id="{ item }">
        <a @click="statusAction(item)">{{ item.click_rf_event_id }}</a>
      </template>
      <template v-slot:item.push_to_transportation="{ item }">
        {{ item.push_to_transportation == 2 ? "Pushed" : "" }}
      </template>
    </v-data-table>
    <v-dialog
      v-model="modal"
      max-width="750px"
      close-delay="ma-5"
      @keydown.esc="modal = false"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Upload</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col>
                <v-file-input
                  v-model="file"
                  counter
                  show-size
                  accept=".xlsx"
                  label="Select your Excel file"
                  :rules="[(v) => !!v || 'Please select Excel File']"
                >
                </v-file-input>
                <v-btn
                  color="primary"
                  dark
                  class="mt-3"
                  :loading="fileLoader"
                  @click="upload"
                >
                  Upload
                </v-btn>

                <v-btn
                  color="info"
                  class="mt-3 ml-3"
                  :loading="downloader"
                  @click="download()"
                  >Download template</v-btn
                >
                <v-btn
                  class="mt-3 ml-3"
                  @click="
                    modal = false;
                    $refs.form.reset();
                  "
                >
                  Cancel
                </v-btn>
                <v-col class="pl-0 d-flex">
                  <table class="ml-0">
                    <thead>
                      <tr>
                        <th>Product Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in ProductType" :key="item">
                        <td>{{ item }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table class="ml-0">
                    <thead>
                      <tr>
                        <th>Container Type</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(item, i) in containerType" :key="item">
                        <td>{{ i }}</td>
                      </tr>
                    </tbody>
                  </table>
                </v-col>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="transportPage" scrollable width="650">
      <v-card>
        <v-card-title style="display: inline">Transport Summary</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 400px; width: 650px">
          <template>
            <div
              class="history-tl-container-order pl-6"
              v-for="data in trackingDetails"
              :key="data"
            >
              <ul class="tl p-0 mb-0">
                <li class="tl-item" ng-repeat="item in retailer_history">
                  <div class="vertical-line">
                    <v-icon class="icon">mdi-truck-delivery-outline</v-icon>
                  </div>

                  <div cols="12" md="12">
                    <div class="timestamp">
                      {{
                        data.utc_datetime
                          | localMoment
                          | moment("DD MMM, YYYY hh:mm A")
                      }}
                      <br />
                      <div class="text-center mt-4">
                        {{ data.timezone }}
                      </div>
                    </div>
                  </div>
                  <div cols="12" md="12" class="d-flex">
                    <div class="item-detail" style="float: right">
                      {{ data.event }}
                      <span class="status" v-if="data.notify_status == -1">
                        Internal Status
                      </span>
                      <span class="statusYellow" v-if="data.notify_status == 1">
                        Pending to be sent to DOW
                      </span>
                      <span class="statusGreen" v-if="data.notify_status == 2">
                        Sent to DOW
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-end">
          <v-btn color="white" variant="text" @click="transportPage = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <BulkErrors
      :dialog="uploadResDialog"
      :data="uploadRes"
      @close="uploadResDialog = false"
    />
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import BulkErrors from "@/components/front/common/BulkErrors";

export default {
  components: { BulkErrors },
  computed: {
    ...mapGetters(["userCategory"]),
  },
  data: () => ({
    uploadResDialog: false,
    uploadRes: {},

    headers: [
      {
        text: "Tender Request Number",
        value: "tender_request_number",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },
      {
        text: "Reference Number",
        value: "shipment_reference_number",
        class: "body-1 font-weight-bold",
        width: "200px",
        sortable: false,
      },
      {
        text: "Address",
        value: "origin_address_name",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Container Number",
        value: "container_number",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Product Type",
        value: "product_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Seal Value",
        value: "seal_value",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Status",
        value: "click_rf_event_id",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Booking Number",
        value: "booking_number",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Pushed To Transportation",
        value: "push_to_transportation",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Weight",
        value: "weight",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    total: "",
    listLoader: false,
    options: {},
    modal: false,
    filtersArr: [],
    number: null,
    transportPage: false,
    ProductType: [],
    containerType: [],
    seal_number: null,
    shipment_reference_number: null,
    container_number: null,
  }),

  created() {},
  watch: {
    options: {
      handler() {
        this.fetchList();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "snackBar",
      "getTransportList",
      "transportTracking",
      "downloadTransport",
      "uploadTransport",
    ]),
    download() {
      this.downloader = true;
      this.downloadTransport()
        .then((res) => {
          this.fileDownload(res);
          this.snackBar({
            color: "success",
            message: "Data downloaded successfully",
          });
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    clearAll() {
      this.container_number = null;
      this.number = null;
      this.seal_number = null;
      this.shipment_reference_number = null;
      this.container_number = null;
      this.click_rf_event_id = null;
      this.fetchList();
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        request_no: this.number,
        seal_value: this.seal_number,
        shipment_reference_number: this.shipment_reference_number,
        container_number: this.container_number,
        click_rf_event_id: this.click_rf_event_id,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.listLoader = true;
      this.allFilters();
      this.getTransportList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.listLoader = false;
          this.list = res.data.records;
          this.containerType = res.data.container_type_code;
          this.ProductType = res.data.product_type;

          this.total = res.data.total;
        })
        .catch(() => {
          this.listLoader = false;
        });
    },
    upload() {
      if (!this.$refs.form.validate()) return;
      const payload = new FormData();
      this.fileLoader = true;
      payload.append("data_file", this.file);
      this.uploadTransport(payload)
        .then((res) => {
          this.modal = false;
          this.fileLoader = false;
          this.uploadResDialog = true;
          this.uploadRes = res.data;

          // this.snackBar({
          //   color: "success",
          //   message: res.data.message,
          // });
        })
        .catch(() => {
          this.fileLoader = false;
          this.modal = false;
        });
      this.$refs.form.reset();
      this.fetchList();
    },
    fetchList() {
      this.list = [];
      this.listLoader = true;
      this.getTransportList({
        ...this.options,
      })
        .then((res) => {
          this.listLoader = false;
          this.list = res.data.records;
          this.containerType = res.data.container_type_code;
          this.ProductType = res.data.product_type;
          this.total = res.data.total;
        })
        .catch(() => {
          this.listLoader = false;
        });
    },
    statusAction(item) {
      this.transportTracking(item.id).then((res) => {
        this.trackingDetails = res.data.events;
        this.transportPage = true;
      });
    },
  },
};
</script>
<style scoped>
table {
  border-collapse: collapse;
  width: 50%;
  margin: 20px;
}

th,
td {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

th {
  background-color: #f2f2f2;
}
</style>
<style lang="scss">
.theme--light.v-data-table.custom-class
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  padding-left: 12px;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.v-data-table.custom-class > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: 0.875rem;
  height: 48px;
  padding-left: 12px;
}

.mt {
  margin-top: 16px;
}
ul.tl li .item-detail {
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
}
ul.tl li .timestamp {
  color: #8d8d8d;
  position: absolute;
  margin-left: -164px;
  text-align: right;
  font-size: 12px;
}
.history-tl-container-order {
  height: 45px;
  font-family: "Roboto", sans-serif;
  width: 60%;
  margin-left: 31%;
  display: block;
  position: relative;
  top: -3px;
}
.history-tl-container-order-details {
  font-family: "Roboto", sans-serif;
  width: 60%;
  margin-left: 36.5%;
  display: block;
  position: relative;
}
.history-tl-container-order ul.tl {
  padding: 0;
  display: inline-block;
}
.history-tl-container-order ul.tl li {
  list-style: none;
  margin-left: 0;
  /*background: rgba(255,255,0,0.1);*/
  // border-left: 1px solid black;
  padding: 0 0 20px 20px;
  // position: relative;
  // height: 45px;
  line-height: 1px;
}
.history-tl-container-order-details ul.tl li {
  list-style: none;
  margin-left: 0;
  /*background: rgba(255,255,0,0.1);*/
  // border-left: 1px solid black;
  padding: 0 0 10px 20px;
  // position: relative;
  line-height: 1px;
}

.height-order {
  height: 40px !important;
}
.tracingNo {
  font-size: 12px;
  float: right;
}
/* Icon with horizontal lines */
.icon-inside {
  position: relative; /* Ensure proper positioning */
  display: inline-block; /* Allow lines to be displayed correctly */
  color: black; /* Icon color */
}

/* Container for the vertical line and icon */
.vertical-line {
  position: relative;
  display: inline-block;
  left: -30px;
  top: 12px;
}

/* Vertical line */
.vertical-line::before {
  content: "";
  position: absolute;
  top: 16px;
  left: 43%;
  transform: translateX(-50%);
  height: 33px;
  width: 1px;
  background-color: black;
}

/* Icon */
.icon {
  position: relative; /* Ensure the icon is in front of the line */
  font-size: 24px; /* Adjust icon size as needed */
  z-index: 1; /* Place the icon above the line */
}

.status {
  background-color: lightskyblue;
  font-weight: bold;
  color: black;
  padding: 3px;
  border-radius: 5px;
  margin-left: 10px !important;
  line-height: 10px;
}
.statusGreen {
  background-color: lightgreen;
  font-weight: bold;
  color: black;
  padding: 3px;
  border-radius: 5px;
  margin-left: 10px !important;
  line-height: 10px;
}
.statusYellow {
  background-color: yellow;
  font-weight: bold;
  color: black;
  padding: 3px;
  border-radius: 5px;
  margin-left: 10px !important;
  line-height: 10px;
}
</style>
